var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.goodsList.length > 0
    ? _c(
        "div",
        { staticClass: "popular border-radius-8" },
        [
          !_vm.isnopage
            ? _c("div", { staticClass: "title" }, [_vm._v("猜你喜欢")])
            : _c("div", { staticClass: "title" }, [_vm._v("为您推荐")]),
          _vm._v(" "),
          _vm.isnopage ? _c("i", { staticClass: "no-page-line" }) : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "infinite-scroll",
                  rawName: "v-infinite-scroll",
                  value: _vm.loadMore,
                  expression: "loadMore",
                },
              ],
              staticClass: "popular-list",
              attrs: {
                "infinite-scroll-disabled": _vm.loading,
                "infinite-scroll-distance": "50",
              },
            },
            [
              _c("goods-list", {
                attrs: {
                  goodsList: _vm.popular,
                  viewTrackData: _vm.viewDataTrack,
                },
                on: { "click-goods-item": _vm.clickGoodsItem },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isShowNoMore ? _vm._t("default") : _vm._e(),
          _vm._v(" "),
          _vm.isShowNoMore
            ? _c("div", { staticClass: "no-more" }, [
                _vm._v("- 我是有底线的 -"),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "p",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isShowNoMore,
                  expression: "!isShowNoMore",
                },
              ],
              staticClass: "page-infinite-loading",
              class: { "page-loading-visible": !_vm.loading },
            },
            [
              _c("mt-spinner", { attrs: { type: "fading-circle" } }),
              _vm._v("加载中...\n  "),
            ],
            1
          ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }